import Label from '../../../../ui/label'
import { useDispatch } from 'react-redux';
import { setUpdateLoanMaturityMonths } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice';
import Input from '../../../../ui/input';
import { customStyle, defaultStyle } from '../../../../../constant/custom-style';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

interface Props {
    isPreview?: boolean;
}

export default function ClientInputLoanMaturity({ isPreview }: Props) {

    const dispatch = useDispatch();
    const { loanMaturity, maturityMonths, maturityMonthsFormat } = useProposalTypeData();

    const handleChange = (value: string) => {
        const numericValue = parseFloat(value.replace(/,/g, ""));
        dispatch(setUpdateLoanMaturityMonths(numericValue))
    };

    return (
        <div className="">
            <div className="flex items-start gap-2.5 border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-3 py-3 sm:px-4">
                {/* TITLE & DESCRIPTION */}
                <div className="min-w-0">
                    <Label
                        label="Loan Maturity"
                        isRequired={true}
                        requiredText=" *"
                        fontSize="text-xs"
                        fontWeight="font-semibold text-gray-800"
                    />
                    <p className="mt-0.5 text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                        Enter a loan maturity between 1 and 60 months.
                    </p>
                </div>
            </div>

            {isPreview ? (
                <div className="flex min-h-[72px] items-center gap-3 rounded-lg border border-[#186cb2] bg-[#186cb2]/5 px-4 py-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#186cb2] text-sm font-semibold text-white">
                        {maturityMonths || '-'}
                    </div>
                    <div>
                        <p className="text-xs text-gray-500">Loan maturity period</p>
                        <p className="text-sm font-semibold text-gray-900">
                            {loanMaturity?.name || `${maturityMonths || '-'} Month${Number(maturityMonths) === 1 ? '' : 's'}`}
                        </p>
                    </div>
                </div>
            ) : (
                <div className='p-3'>
                    <div className="relative">
                        <Input
                            maxLength={2}
                            type="text"
                            name="groupName"
                            value={maturityMonthsFormat}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${
                                !maturityMonths
                                    ? ''
                                    : customStyle
                            }`}
                            onChange={(e) => handleChange(e.target.value)}
                            required={true}
                            placeholder="Enter loan maturity"
                            // disabled={!isComplete}
                        />
                        <span className="pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-xs font-medium text-gray-500">
                            Months
                        </span>
                    </div>
                </div>
            )}
        </div>
    )
}